import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {OptionData} from 'ui-library/menus/MenuConstants';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

export interface ReviewStageDropdownProps {
  selectedDropdownOption: OptionData;
  onSelectDropdownOption: (dropdownOption: OptionData) => void;
  allDropdownOptions: Array<OptionData>;
  dataTestAttrs?: DataTestAttrs;
}

export default function ReviewStageDropdown(props: ReviewStageDropdownProps): JSX.Element {
  return (
    <SelectDropdown
      displayName={props.selectedDropdownOption.name}
      className={css(styles.dropdown)}
      dataTestAttrs={props.dataTestAttrs}
      menu={
        <SearchableMenu
          selectedValue={props.selectedDropdownOption.name}
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.FULL}
          scrollable={true}
          optionDatas={props.allDropdownOptions}
          onSelect={(value) => {
            props.onSelectDropdownOption(
              props.allDropdownOptions.filter((option) => option.value === value)[0]
            );
          }}
        />
      }
    />
  );
}

const styles = StyleSheet.create({
  dropdown: {
    flex: '0.9',
    whiteSpace: 'normal',
  },
});
